var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{staticClass:"mr-sm-2 mx-0",attrs:{"id":"faculty-list-select","options":_vm.facultyOptions},model:{value:(_vm.local_faculty_id),callback:function ($$v) {_vm.local_faculty_id=$$v},expression:"local_faculty_id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }